import { render, staticRenderFns } from "./tama-job-requests-icon.vue?vue&type=template&id=6f601ebb"
import script from "./tama-job-requests-icon.vue?vue&type=script&lang=js"
export * from "./tama-job-requests-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports